import { type HTMLAttributes, forwardRef } from 'react'
import { cn } from '@/lib/utils'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Elevate with a subtle gold ring on hover */
  hoverable?: boolean
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { hoverable = false, className, children, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'bg-cosmic-nebula/50 ring-1 ring-white/5 rounded-2xl backdrop-blur',
        hoverable && [
          'transition-all duration-200 cursor-default',
          'hover:bg-cosmic-nebula/70 hover:ring-gold/10 hover:shadow-card-hover',
        ],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})

/** A pre-padded Card with a title slot and optional action. */
export function CardSection({
  title,
  action,
  children,
  className,
}: {
  title?: React.ReactNode
  action?: React.ReactNode
  children: React.ReactNode
  className?: string
}) {
  return (
    <Card className={cn('p-5', className)}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <h3 className="text-sm font-medium text-star-bright tracking-tight">{title}</h3>
          )}
          {action}
        </div>
      )}
      {children}
    </Card>
  )
}
